import React from 'react';
import { motion } from 'framer-motion';

const AskPlaPi = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="max-w-6xl mx-auto px-4 py-12"
    >
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-green-500 to-teal-500 bg-clip-text text-transparent mb-6">
          Pregúntale a PlaPi
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">
          Obtén respuestas personalizadas a tus dudas sobre plagio y propiedad intelectual
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
        <iframe 
          src="https://client.fineguide.ai/979feeb2-ad11-4729-bc76-4783c2901a33" 
          style={{
            border: 'none',
            width: '100%',
            height: '650px'
          }}
          title="Pregúntale a PlaPi"
        />
      </div>
    </motion.div>
  );
};

export default AskPlaPi;